import React, { useState } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from '../../utility/axios';
import '../../styles/auth/ForgotPassword.css';

const ForgotPassword = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            await axios.post('/api/forgot-password/', {
                email: values.email
            });
            message.success(t('auth.forgotPassword.resetSent'));
            form.resetFields();
        } catch (error) {
            message.error(error.response?.data?.error || t('auth.forgotPassword.errorOccurred'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="forgot-password-wrapper">
            <div className="forgot-password-container">
                <Card title={t('auth.forgotPassword.title')} className="forgot-password-card">
                    <p className="forgot-password-description">
                        {t('auth.forgotPassword.instruction')}
                    </p>
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleSubmit}
                    >
                        <Form.Item
                            name="email"
                            rules={[
                                { required: true, message: t('common.validation.required') },
                                { type: 'email', message: t('common.validation.email') }
                            ]}
                        >
                            <Input 
                                prefix={<MailOutlined />} 
                                placeholder={t('auth.forgotPassword.email')}
                                size="large"
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button 
                                type="primary" 
                                htmlType="submit" 
                                loading={loading}
                                block
                                size="large"
                            >
                                {t('auth.forgotPassword.sendReset')}
                            </Button>
                        </Form.Item>
                    </Form>
                    
                    <div className="auth-links">
                        <Link to="/login">{t('auth.forgotPassword.backToLogin')}</Link>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default ForgotPassword;
